import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { LoginComponent } from './login.component';
import { ForgottenPasswordComponent } from './forgottenPassword.component';
import { ResetPasswordComponent } from './resetPassword.component';
import { LogOutComponent } from './log.out.successful.component';
import { RouterModule } from '@angular/router';
import { PagingModule } from '../../components/common/search/paging.module';
import { ValidationModule } from '../../components/common/validation/validation.module';
import { B2BAngularMaterialModule } from '../../components/common/angular.material/b2b.angular.material.module';
import { CategoryTreeViewModule } from '../../components/common/category.tree.view/category.tree.view.module';
import { BlockUIModule } from 'ng-block-ui';

@NgModule({
    declarations: [LoginComponent, ForgottenPasswordComponent, ResetPasswordComponent, LogOutComponent],
    imports: [BrowserModule, FormsModule, RouterModule, PagingModule, ValidationModule, B2BAngularMaterialModule, CategoryTreeViewModule, BlockUIModule]
})

export class UserAccountModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/userAccounts/userAccounts.module.ts